import React from 'react'

function ToggleSwitch(props) {
  const { name, switchVal, setSwitchVal, updateStatus } = props
  return (
    <span className="toggle-switch">
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={name}
        id={name}
        checked={switchVal}
        onClick={() => { updateStatus(!switchVal); setSwitchVal(val => !val) }}
      />
      <label className="toggle-switch-label" htmlFor={name}>
        <span className="toggle-switch-inner" />
        <span className="toggle-switch-switch" />
      </label>
    </span>
  )
}

export default ToggleSwitch
